module.exports = __webpack_public_path__ + "static/img/szst.6b22814e.png";